import { enumMapToMultiDropdownOptions } from '@instinet-analytics/core-lib';
import { MultiDropdownDropdownItem } from '@instinet-analytics/semantic-ui-components';

export enum IndexEventTradeCategoryType {
    'ADD' = 'Addition',
    'DEL' = 'Deletion',
    'FIFD' = 'Float Decrease',
    'FIFI' = 'Float Increase',
    'FUND' = 'Funding',
    'REIN' = 'Reinvestment',
    'SI' = 'Share Increase',
    'SD' = 'Share Decrease',
    'WI' = 'Weight Increase',
    'WD' = 'Weight Decrease',
    'BUY' = 'Buy',
    'SELL' = 'Sell',
    'RECL' = 'Reclassification',
    'CFD' = 'Capping Factor Change',
}

export function useIndexEventsTradeCategories(): MultiDropdownDropdownItem<string>[] {
    // TODO= source this from a Rest call
    return enumMapToMultiDropdownOptions(
        IndexEventTradeCategoryType,
        true
    ) as MultiDropdownDropdownItem<string>[];
}
